<div 
  #videoContainer
  class="video" 
  [ngClass]="provider()"
  [class.embed-video]="!src()" 
  [class.hide-controls]="hideControls()" 
  [class.hidden]="!(initialized | async)">

  @if (src() && showPlayer()) {
    @if (preventVideoLoad && poster()) {
      <img class="video__thumbnail" [src]="poster()?.uri" alt="">
    }

    <div class="plyr-player-wrapper">
      <video
        #videoPlayer 
        id="video-player"
        controls
        crossorigin="anonymous"
        [attr.x5-video-player-fullscreen]="x5Attributes() ? false : null"
        [attr.x5-video-player-type]="x5Attributes() ? 'h5' : null">
      </video>
    </div>
    @if (warningMessage) {
      <div class="video__warning-message">
        <mat-icon class="video__warning-message-icon">error</mat-icon>
        <span class="video__warning-message-title">{{ warningMessage | translate }}</span>
        <mat-icon class="video__warning-message-close" (click)="hideWarningMessage()">close</mat-icon>
      </div>
    }

    @if (interactiveData) {
      <div class="interactive-video-overlay" [class.block-video-click]="isKeyFrameActive && !isAdmin">
        @if (plyr?.stopped) {
          <div class="interactive-video-play-button-wrapper">
            <div class="interactive-video-play-button secondary-background" (click)="startVideo()">
              Start interactive video
            </div>
          </div>
        }

        @if (nextKeyFrame && isKeyFrameActive) {
          @for (decision of nextKeyFrame.decisions; track decision) {
            <div
              class="interactive-video-decision"
              (click)="keyFrameAction(decision)"
              [style.width.%]="decision.w / interactiveData.script.videoWidth * 100"
              [style.height.%]="decision.h / interactiveData.script.videoHeight * 100"
              [style.left.%]="decision.x / interactiveData.script.videoWidth * 100"
              [style.top.%]="decision.y / interactiveData.script.videoHeight * 100"
            ></div>
          }
        }
      </div>
    }
  } @else {
    @if (embed) {
      @if (showThumbnailsForEmbed() && !userStartWatchingVideo) {
        @if (!useCustomThumbnailForEmbed()) {
          @if (embedThumbnail | async; as thumbnail) {
            <img class="video__thumbnail" [src]="thumbnail" alt="Video thumbnail" (click)="startVideo()">
          }
        } @else {
          @if (poster()) {
            <div class="video__thumbnail" [mediaBackground]="{ mediaBackground: poster() }" (click)="startVideo()">
              <mat-icon class="video__thumbnail-play">play_arrow</mat-icon>
            </div>
          }
        }
      }

      @switch (embed.provider) {
        @case ('youtube') {
          <app-youtube-player (started)="videoStarted()" (watched)="end()" [videoId]="embed.id" [startTime]="embed.start"></app-youtube-player>
        }

        @case ('vimeo') {
          <app-vimeo-player (started)="videoStarted()" (watched)="end()" [videoId]="embed.id" [hash]="embed.hash"></app-vimeo-player>
        }
      }
    }
  }
</div>
